import { useState } from "react"
import { Badge } from "@/components/ui/badge"
import { Input } from "@/components/ui/input"
import { X } from "lucide-react"

interface KeywordEditorProps {
  keywords: string[]
  onChange: (keywords: string[]) => void
}

export function KeywordEditor({ keywords, onChange }: KeywordEditorProps) {
  const [input, setInput] = useState("")

  const addKeyword = () => {
    const keyword = input.trim().toLowerCase()
    if (keyword && !keywords.includes(keyword)) {
      onChange([...keywords, keyword])
    }
    setInput("")
  }

  const removeKeyword = (keyword: string) => {
    onChange(keywords.filter((k) => k !== keyword))
  }

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-muted-foreground">
        Keywords
      </label>
      <div className="flex flex-wrap gap-1.5">
        {keywords.map((keyword) => (
          <Badge key={keyword} variant="secondary" className="gap-1 pr-1">
            {keyword}
            <button
              type="button"
              onClick={() => removeKeyword(keyword)}
              className="ml-0.5 rounded-sm hover:bg-muted p-0.5"
            >
              <X className="h-3 w-3" />
            </button>
          </Badge>
        ))}
      </div>
      <Input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault()
            addKeyword()
          }
        }}
        placeholder="Type a keyword and press Enter (e.g. autoimmune, diabetes)"
        className="max-w-xs text-sm"
      />
    </div>
  )
}
